// extracted by mini-css-extract-plugin
module.exports = {"component":"DoCGTWPJ0dSwBs3nZR-3o","leftRemoveButton":"_3SLDAHtUls33xZiJO-issM","hiddenRemoveButton":"vFFru7GWo-A65pucEmoj6"};